<style scoped>
input {
  font-size: 100%;
}
input[type="range"] {
  width: 100%;
  cursor: pointer;
}
#contents {
  width: 100%;
  height: 100%;
  min-height: 100%;
}
#contentsBody {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
}
#parameterArea {
  width: 335px;
  margin-top: 20px;
  margin-right: -335px;
  float: left;
}
#parameterTable th,
#parameterTable td {
  border-bottom: 1px solid #ffffff;
  padding-left: 15px;
  padding-right: 5px;
}
#parameterTable th {
  width: 150px;
  text-align: left;
  color: #ffffff;
  padding: 10px;
  background-color: #595148;
}
#inputText {
  width: 5em;
  margin: 0px;
  text-align: right;
}
#chartArea {
  width: 100%;
  height: 100%;
  float: right;
}
#chartContent {
  width: 33em;
  height: 100%;
  margin-left: 350px;
  margin-top: 10px;
  margin-right: 40px;
  text-align: center;
}
#chart {
  height: 100%;
  width: 100%;
}
#parameterTable {
  border: 2px #808080 solid;
  border-collapse: collapse;
}
#authorityArea {
  font-size: 0.9em;
  margin-top: 10px;
}
#yearText {
  width: 3em;
  margin: 0px 10px;
  text-align: right;
}
#forecastButton {
  width: 21em;
  border-radius: 5px;
  color: #ffffff;
  background-color: #595148;
  margin-top: 10px;
}
#labelText {
  font-size: 12px;
}
.clearfix {
  content: "";
  display: block;
  clear: both;
  height: 0;
  visibility: hidden;
}
.errorParameter {
  color: red;
}
</style>

<template>
  <div id="contents">
    <div ref="contents" id="contentsBody">
      <div id="chartArea">
        <div id="chartContent" ref="chartContent">
          <div id="yearArea">
            <span>予想する時点</span>
            <input
              id="yearText"
              type="number"
              v-bind:min="year.min"
              v-bind:max="year.max"
              v-bind:step="year.step"
              v-model="year.value"
            />
            <span>年後</span>
            <br />
            <input
              type="range"
              v-bind:min="year.min"
              v-bind:max="year.max"
              v-bind:step="year.step"
              v-model="year.value"
            />
          </div>
          <chart id="chart" ref="chart" :height="750" />
        </div>
      </div>

      <div id="parameterArea">
        <table id="parameterTable">
          <tr>
            <th>性別</th>
            <td>
              <input
                type="radio"
                id="sexmale"
                name="Sex"
                value="1"
                v-model="parameter.Sex.value"
              />
              <label for="sexmale">男性 </label>
              <input
                type="radio"
                id="sexfemale"
                name="Sex"
                value="0"
                v-model="parameter.Sex.value"
              />
              <label for="sexfemale">女性</label>
            </td>
          </tr>
          <tr>
            <th>年齢</th>
            <td>
              <input
                id="inputText"
                type="number"
                min="0"
                name="Age"
                v-model="parameter.Age.value"
              />
              <label> 歳</label>
            </td>
          </tr>
          <tr>
            <th>身長</th>
            <td>
              <input
                id="inputText"
                type="number"
                min="0"
                name="Height"
                v-model="parameter.Height.value"
              />
              <label> cm</label>
            </td>
          </tr>
          <tr>
            <th>体重</th>
            <td>
              <input
                id="inputText"
                type="number"
                min="0"
                name="Weight"
                v-model="parameter.Weight.value"
              />
              <label> kg</label>
            </td>
          </tr>
          <tr>
            <th>糖尿病網膜症</th>
            <td>
              <input
                type="radio"
                id="DiabeticRetinopathyNo"
                name="DiabeticRetinopathy"
                value="false"
                v-model="parameter.DiabeticRetinopathy.value"
              />
              <label for="DiabeticRetinopathyNo">なし </label>
              <input
                type="radio"
                id="DiabeticRetinopathyYes"
                name="DiabeticRetinopathy"
                value="true"
                v-model="parameter.DiabeticRetinopathy.value"
              />
              <label for="DiabeticRetinopathyYes">あり</label>
            </td>
          </tr>
          <tr>
            <th>心房細動</th>
            <td>
              <input
                type="radio"
                id="AFNo"
                name="AF"
                value="false"
                v-model="parameter.AF.value"
              />
              <label for="AFNo">なし </label>
              <input
                type="radio"
                id="AFYes"
                name="AF"
                value="true"
                v-model="parameter.AF.value"
              />
              <label for="AFYes">あり</label>
            </td>
          </tr>
          <tr>
            <th>運動習慣</th>
            <td>
              <input
                type="radio"
                id="ExerciseNo"
                name="Exercise"
                value="false"
                v-model="parameter.Exercise.value"
              />
              <label for="ExerciseNo">なし </label>
              <input
                type="radio"
                id="ExerciseYes"
                name="Exercise"
                value="true"
                v-model="parameter.Exercise.value"
              />
              <label for="ExerciseYes">あり</label>
            </td>
          </tr>
          <tr>
            <th>現在喫煙</th>
            <td>
              <input
                type="radio"
                id="SmokerNo"
                name="Smoker"
                value="false"
                v-model="parameter.Smoker.value"
              />
              <label for="SmokerNo">なし </label>
              <input
                type="radio"
                id="SmokerYes"
                name="Smoker"
                value="true"
                v-model="parameter.Smoker.value"
              />
              <label for="SmokerYes">あり</label>
            </td>
          </tr>
          <tr>
            <th>糖尿病罹患期間</th>
            <td>
              <input
                id="inputText"
                type="number"
                min="0"
                name="YearsAfterDignosis"
                v-model="parameter.YearsAfterDignosis.value"
              />
              <label> 年</label>
            </td>
          </tr>
          <tr>
            <th>HbA1c(NGSP値)</th>
            <td>
              <input
                id="inputText"
                type="number"
                min="0"
                step="0.1"
                name="HbA1c"
                v-model="parameter.HbA1c.value"
              />
              <label> %</label>
            </td>
          </tr>
          <tr>
            <th>収縮期血圧</th>
            <td>
              <input
                id="inputText"
                type="number"
                min="0"
                name="SBP"
                v-model="parameter.SBP.value"
              />
              <label> mmHg</label>
            </td>
          </tr>
          <tr>
            <th>総コレステロール</th>
            <td>
              <input
                id="inputText"
                type="number"
                min="0"
                name="TotalC"
                v-model="parameter.TotalC.value"
              />
              <label> mg/dL</label>
            </td>
          </tr>
          <tr>
            <th>HDLコレステロール</th>
            <td>
              <input
                id="inputText"
                type="number"
                min="0"
                name="HDLC"
                v-model="parameter.HDLC.value"
              />
              <label> mg/dL</label>
            </td>
          </tr>
          <tr>
            <th>尿アルブミン</th>
            <td>
              <input
                id="inputText"
                type="number"
                min="0"
                name="ACR"
                v-model="parameter.ACR.value"
              />
              <label id="labelText"> mg/gCre</label>
            </td>
          </tr>
        </table>
        <input
          id="forecastButton"
          type="submit"
          v-on:click="loadRisk"
          value="予測"
        />
        <div id="authorityArea">
          日本全国の2型糖尿病患者コホート(JDCS/J-EDIT)のデータにより作成された予測モデルに基づき、
          入力された条件と同等の方が5年以内に糖尿病合併症を発症確率を表示するシステムです。
          <br />(出典: Tanaka S, et al. Diabetes Care 36:1193, Epub 2013 Feb
          12.)
        </div>
      </div>
      <div class="clearfix" />
    </div>

    <v-dialog style="white-space: pre-wrap; word-wrap: break-word"></v-dialog>
  </div>
</template>

<script>
import Chart from "./JJRiskChart";
import axios from "axios";

export default {
  name: "JJRiskChartView",
  data: function () {
    return {
      year: {
        min: 1.0,
        max: 10.0,
        step: 0.5,
        value: 5.0,
      },
      parameter: {
        Sex: { value: 1, unit: null, isError: false },
        Age: { value: "", unit: null, isError: false },
        Height: { value: "", unit: null, isError: false },
        Weight: { value: "", unit: null, isError: false },
        DiabeticRetinopathy: { value: false, unit: null, isError: false },
        AF: { value: false, unit: null, isError: false },
        Exercise: { value: false, unit: null, isError: false },
        Smoker: { value: false, unit: null, isError: false },
        YearsAfterDignosis: { value: "", unit: null, isError: false },
        HbA1c: { value: "", unit: null, isError: false },
        SBP: { value: "", unit: null, isError: false },
        TotalC: { value: "", unit: null, isError: false },
        HDLC: { value: "", unit: null, isError: false },
        ACR: { value: "", unit: null, isError: false },
      },
      risks: [],
    };
  },
  watch: {
    "year.value": function () {
      this.updateChart();
    },
  },
  methods: {
    createFactor() {
      return {
        InspectionResults: {
          Sex: this.parameter.Sex.value,
          Age: this.parameter.Age.value,
          Height: this.parameter.Height.value,
          Weight: this.parameter.Weight.value,
          DiabeticRetinopathy: this.parameter.DiabeticRetinopathy.value,
          AF: this.parameter.AF.value,
          Exercise: this.parameter.Exercise.value,
          Smoker: this.parameter.Smoker.value,
          YearsAfterDignosis: this.parameter.YearsAfterDignosis.value,
          HbA1c: this.parameter.HbA1c.value,
          SBP: this.parameter.SBP.value,
          TotalC: this.parameter.TotalC.value,
          HDLC: this.parameter.HDLC.value,
          ACR: this.parameter.ACR.value,
        },
      };
    },
    loadRisk: function () {
      const factor = this.createFactor();

      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const that = this;
      axios
        .post("/api/JJRiskChart", factor)
        .then(function (res) {
          if (res.data.IsSuccess) {
            that.risks = res.data.Risks;
            that.updateChart();
            that.setYAxesMax();
          } else {
            that.$modal.show("dialog", {
              title: "エラー",
              text: res.data.Message,
              buttons: [
                {
                  title: "閉じる",
                  handler: function () {
                    that.$modal.hide("dialog");
                  },
                },
              ],
            });
          }
        })
        .catch(function (res) {
          that.$modal.show("dialog", {
            title: "エラー",
            text: res.message,
            buttons: [
              {
                title: "閉じる",
                handler: function () {
                  that.$modal.hide("dialog");
                },
              },
            ],
          });
        });
    },
    setYAxesMax: function () {
      const lastItem = this.risks[this.risks.length - 1];
      const yAxesMax = Math.max(
        lastItem.CHD,
        lastItem.Stroke,
        lastItem.NonCVMortality,
        lastItem.Nephropathy,
        lastItem.Retinopathy
      );

      this.$refs.chart.setYAxesMax(yAxesMax);
    },
    updateChart: function () {
      const idx =
        (Number(this.year.value) - Number(this.year.min)) / this.year.step;
      if (this.risks == null || this.risks.length <= idx) {
        return;
      }
      this.$refs.chart.updateChartData(this.risks[idx]);
    },
    rerender: function () {
      this.$refs.chart.height = 750;
      document.getElementById("bar-chart").style.height = "750px";
    },
  },
  components: {
    Chart,
  },
};
</script>
